import React, { useState } from "react";
import styles from "./passwordmanagment.module.css";
import { InputField, SubmitButton } from "../../../components";
import { VscEye } from "react-icons/vsc";
import { TbEyeClosed } from "react-icons/tb";
import HeadingComponent from "../../../components/HeadingComponent/HeadingComponent";
import { useDispatch } from "react-redux";
import { showAlert } from "../../../Store/Actions/GeneralActions";
import { PagesMiddleware } from "../../../Store/Middlewares/PagesMiddleware";

const Passwordmanagment = () => {

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirnPassword, setConfirnPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [NpasswordVisible, setNPasswordVisible] = useState(false);
  const [CpasswordVisible, setCPasswordVisible] = useState(false);
  const dispatch = useDispatch();

  const onChangePassword = () => {
    if (!currentPassword || !newPassword || !confirnPassword) {
      dispatch(showAlert({ message: "Please fill all the fields", type: "warning" }))
    }
    else if (newPassword !== confirnPassword) {
      dispatch(showAlert({ message: "Passwords do not match", type: "warning" }))
    }
    else {
      const data = {
        currentPassword: currentPassword,
        newPassword: newPassword,
      };
      dispatch(PagesMiddleware.onResetPassword(data))
        .then((res) => {
          setCurrentPassword("");
          setNewPassword("");
          setConfirnPassword("")
         })
        .catch((err) => { console.log("error", err) });
    }
  }


  return (
    <div className={styles.AccountContent}>
      <HeadingComponent text={"Change Password"} fontSize={20} padding={'0px'} />

      <InputField
        label={"Current Password"}
        style={{ marginTop: "30px" }}
        placeholder={"●●●●●●●●●●"}
        value={currentPassword}
        onChange={(e) => setCurrentPassword(e.target.value)}
        rightIcon={
          passwordVisible ? (
            <VscEye size={20} color={"var(--input-icon)"} />
          ) : (
            <TbEyeClosed size={20} color={"var(--input-icon)"} />
          )
        }
        onRightIconPress={() => setPasswordVisible(!passwordVisible)}
        type={passwordVisible ? "text" : "password"}
      />

      <InputField
        label={"New Password"}
        style={{ marginTop: "20px" }}
        placeholder={"●●●●●●●●●●"}
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
        rightIcon={
          NpasswordVisible ? (
            <VscEye size={20} color={"var(--input-icon)"} />
          ) : (
            <TbEyeClosed size={20} color={"var(--input-icon)"} />
          )
        }
        onRightIconPress={() => setNPasswordVisible(!NpasswordVisible)}
        type={NpasswordVisible ? "text" : "password"}
      />
      <InputField
        label={"Confirm New Password"}
        style={{ marginTop: "20px" }}
        placeholder={"●●●●●●●●●●"}
        value={confirnPassword}
        onChange={(e) => setConfirnPassword(e.target.value)}
        rightIcon={
          CpasswordVisible ? (
            <VscEye size={20} color={"var(--input-icon)"} />
          ) : (
            <TbEyeClosed size={20} color={"var(--input-icon)"} />
          )
        }
        onRightIconPress={() => setCPasswordVisible(!CpasswordVisible)}
        type={CpasswordVisible ? "text" : "password"}
      />

      <SubmitButton
      onClick={onChangePassword}
        title={"Update Password"}
        primary
        style={{ width: "100%", marginTop: "10px" }}

      />
    </div>
  );
};

export default Passwordmanagment;
